export class FieldEntityPair {
  public fieldName: string
  public entityName: string

  constructor(fieldName: string, entityName: string) {
    this.fieldName = fieldName
    this.entityName = entityName
  }

  public equals(item: FieldEntityPair): boolean {
    return this.fieldName === item.fieldName && this.entityName === item.entityName
  }
}
